export class ReportBugFeedbackDTO {
  userId: number;
  type: string;
  description: string;

  constructor() {
    this.userId = 0;
    this.type = '';
    this.description = '';
  }
}
